export const getCurrentPosition = (options = {}) => {
    return new Promise((resolve, reject) => {
        if(navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((pos) => resolve(pos.coords), () => resolve({ latitude: 0, longitude: 0 }), options);
        }else{
            resolve({ latitude: 0, longitude: 0 });
        }
    });
};